import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
import theme from 'styled-theming';
import styledContainerQuery from 'styled-container-query';
import { rem } from 'polished';
import { prefix } from '../../tools/settings';
import Caption from '../Caption';
import Chip from '../Chip';
var iconSize = theme('size', {
  small: rem(16),
  medium: rem(32)
});
var padding = theme('size', {
  small: "".concat(rem(8), " ").concat(rem(32), " ").concat(rem(8), " ").concat(rem(8)),
  medium: "".concat(rem(16), " ").concat(rem(36), " ").concat(rem(16), " ").concat(rem(16))
});
var iconMargin = theme('size', {
  small: rem(8),
  medium: rem(12)
});
var namePadding = theme('size', {
  small: rem(2),
  medium: 0
});
var display = theme('size', {
  small: 'flex',
  medium: 'block'
});
var minNameWidth = theme('size', {
  small: rem(280),
  medium: rem(280)
});
var actionPositionTop = theme('size', {
  small: rem(4),
  medium: rem(10)
});
var actionPositionRight = theme('size', {
  small: rem(4),
  medium: rem(8)
});
var FileLockupContent = styled.div.attrs({
  className: "".concat(prefix, "-file-lockup__content")
}).withConfig({
  displayName: "FileLockupstyles__FileLockupContent",
  componentId: "sc-2r3sfa-0"
})(["display:", ";flex-wrap:wrap;"], display);
var FileLockupNameFull = styled(Caption).attrs({
  isBold: true,
  className: "".concat(prefix, "-file-lockup__name-full")
}).withConfig({
  displayName: "FileLockupstyles__FileLockupNameFull",
  componentId: "sc-2r3sfa-1"
})([""]);
var FileLockupNameShort = styled(Caption).attrs({
  isBold: true,
  className: "".concat(prefix, "-file-lockup__name-short")
}).withConfig({
  displayName: "FileLockupstyles__FileLockupNameShort",
  componentId: "sc-2r3sfa-2"
})([""]);
var FileLockupIcon = styled.div.withConfig({
  displayName: "FileLockupstyles__FileLockupIcon",
  componentId: "sc-2r3sfa-3"
})(["margin-right:", ";img{width:", ";height:", ";}"], iconMargin, iconSize, iconSize);
var FileLockupAction = styled.div.withConfig({
  displayName: "FileLockupstyles__FileLockupAction",
  componentId: "sc-2r3sfa-4"
})(["position:absolute;right:", ";top:", ";"], actionPositionRight, actionPositionTop);
var FileLockupName = styled.div.attrs({
  className: "".concat(prefix, "-file-lockup__name")
}).withConfig({
  displayName: "FileLockupstyles__FileLockupName",
  componentId: "sc-2r3sfa-5"
})(["padding-top:", ";padding-bottom:2px;"], namePadding);
var FileLockupMetadataContainer = styled.div.attrs({
  className: "".concat(prefix, "-file-lockup__metadata-container")
}).withConfig({
  displayName: "FileLockupstyles__FileLockupMetadataContainer",
  componentId: "sc-2r3sfa-6"
})(["display:flex;"]);
var FileLockupMetadata = styled.ul.withConfig({
  displayName: "FileLockupstyles__FileLockupMetadata",
  componentId: "sc-2r3sfa-7"
})(["display:flex;height:", ";align-items:center;margin:0;padding:0;list-style:none;& + .", "-file-lockup__metadata-status-container{margin-top:1px;padding-left:", ";&:before{content:'';display:block;position:absolute;top:3px;bottom:6px;left:8px;width:1px;background:var(--dentsu-color-n500);}}"], rem(19), prefix, rem(16));
var FileLockupMetadataItem = styled.li.attrs({
  className: "".concat(prefix, "-file-lockup__metadata-item")
}).withConfig({
  displayName: "FileLockupstyles__FileLockupMetadataItem",
  componentId: "sc-2r3sfa-8"
})(["min-height:", ";align-items:center;display:inline-flex;+ .", "-file-lockup__metadata-item{padding-left:", ";position:relative;&:before{content:'';display:block;position:absolute;top:4px;bottom:4px;left:8px;width:1px;background:var(--dentsu-color-n300);}}"], rem(19), prefix, rem(16));
var FileLockupMetadataStatus = styled(Chip).attrs({
  size: 'small',
  variant: 'status'
}).withConfig({
  displayName: "FileLockupstyles__FileLockupMetadataStatus",
  componentId: "sc-2r3sfa-9"
})(["max-width:none;margin:0 !important;position:relative;top:-3px;span{margin:2px 0;font-size:var(--dentsu-font-size-12);line-height:1;+ span{margin-left:4px;}}"]);
var FileLockupMetadataStatusContainer = styled.div.attrs({
  className: "".concat(prefix, "-file-lockup__metadata-status-container")
}).withConfig({
  displayName: "FileLockupstyles__FileLockupMetadataStatusContainer",
  componentId: "sc-2r3sfa-10"
})(["position:relative;"]);
var FileLockupMetadataItemContent = styled(Caption).withConfig({
  displayName: "FileLockupstyles__FileLockupMetadataItemContent",
  componentId: "sc-2r3sfa-11"
})(["--dentsu-caption-font-color-light:var(--dentsu-color-n700);text-transform:uppercase;margin-bottom:0;"]);
var FileLockup = styledContainerQuery.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  box-shadow: inset 0 0 0 1px var(--dentsu-color-n150);\n  border-radius: var(--dentsu-radius-4);\n  padding: ", ";\n  min-height: ", ";\n  display: flex;\n  position: relative;\n\n\n  .", "-file-lockup__name-full {\n    display: block;\n  }\n\n  .", "-file-lockup__name-short {\n    display: none;\n  }\n\n  + .", "-file-lockup {\n    margin-top: ", ";\n  }\n\n  &:container(min-width: 400px) {\n    .", "-file-lockup__name {\n      min-width: ", ";\n    }\n  }\n\n  &:container(max-width: 350px) {\n    .", "-file-lockup__content {\n      flex-direction: column;\n    }\n\n    .", "-file-lockup__name-full {\n      display: none;\n    }\n\n    .", "-file-lockup__name-short {\n      display: block;\n    }\n  }\n\n  &:container(max-width: 300px) {\n    .", "-file-lockup__metadata-container {\n      flex-direction: column;\n    }\n\n    .", "-file-lockup__metadata-status-container {\n      padding: 0;\n      &:before {\n        display: none;\n      }\n    }\n  }\n"])), padding, rem(32), prefix, prefix, prefix, rem(8), prefix, minNameWidth, prefix, prefix, prefix, prefix, prefix);
export var Styled = {
  FileLockup: FileLockup,
  FileLockupIcon: FileLockupIcon,
  FileLockupName: FileLockupName,
  FileLockupNameFull: FileLockupNameFull,
  FileLockupNameShort: FileLockupNameShort,
  FileLockupContent: FileLockupContent,
  FileLockupMetadataContainer: FileLockupMetadataContainer,
  FileLockupMetadata: FileLockupMetadata,
  FileLockupMetadataItem: FileLockupMetadataItem,
  FileLockupMetadataItemContent: FileLockupMetadataItemContent,
  FileLockupMetadataStatusContainer: FileLockupMetadataStatusContainer,
  FileLockupMetadataStatus: FileLockupMetadataStatus,
  FileLockupAction: FileLockupAction
};